import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

var OSS = require('ali-oss');

const store = new Vuex.Store({
    state: {
        // 存储token
        Authorization: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        token: localStorage.getItem('token') ? localStorage.getItem('token') : '',
        dataDefault: {
            token: localStorage.getItem("token"),
            phoneImei: "12345678",
            phoneType: 3,
            phoneCode: "ANE-AL00",
            phoneName: "vivo",
            netState: "4G"
        },
        client: new OSS({
            region: 'oss-accelerate',
            //云账号AccessKey有所有API访问权限，建议遵循阿里云安全最佳实践，部署在服务端使用RAM子账号或STS，部署在客户端使用STS。
            accessKeyId: 'LTAI4Fd4FRrnz9vK1Y5HH3KH',
            accessKeySecret: '9TOiTFzaWZvbuOEephU9I58bLfRmg5',
            bucket: 'tax-resource'
        }),
        networkSuccess: true //是否断网
    },

    mutations: {
        // 修改token，并将token存入localStorage
        changeLogin(state, user) {
            state.Authorization = user.Authorization;
            localStorage.setItem('Authorization', user.Authorization);
        },
        changeNetwork(state,val){ //改变状态
            state.networkSuccess = val
        },
        //base转blob
        toBlob(urlData, fileType) {
            let bytes = window.atob(urlData);
            let n = bytes.length;
            let u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bytes.charCodeAt(n);
            }
            return new Blob([u8arr], { type: fileType });
        }
    },
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js